import React, { Component } from 'react'
import { HashRouter as Router, Route} from 'react-router-dom'

import {Wizard, Form} from './formWizard/index'

import Sysadmin from './components/Sysadmin'
import Congrats from './components/Congrats'
import Buh from './components/Buh'
import Software from './components/Software'
import Edo from './components/Edo'

import {Ofd, Ofd3, Ofd5, formData as ofdFormData, typeRender as ofdTypeRender, sendData as ofdSendData} from './components/Ofd'

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Route path="/sysadmin" component={Sysadmin}/>
          <Route path="/buh" component={Buh}/>
          <Route path="/software" component={Software}/>
          <Route path="/edo" component={Edo}/>
          <Route path="/congrats" component={Congrats}/>
          <Route path="/ofd" render={(props) => 
            <Wizard formData={ofdFormData} typeRender={ofdTypeRender} history={props} sendData={ofdSendData}>
              <Form render={Ofd} />
              <Form render={Ofd5} />
              <Form render={Ofd3} />
            </Wizard>
          } />
        </div>
      </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js